export default {
    parts: [
        'visibilitySwitch',
        'removeCollectionButton'
    ],
    baseStyle: {
        visibilitySwitch: {
            '& .chakra-switch__track': {bg: 'webTheme.iconPrimary'},
            '& .chakra-switch__thumb': {bg: 'webTheme.iconOnColor'}
        },
        removeCollectionButton: {
            mt: '24px',
            mb: '16px',
            textTransform: 'none'
        }
    }
}
